import api from "../services/api"

const getAllContacts = async () => {
    try {
        const response = await api.get(`/chat/contacts`)
        const contacts = response.data?.data || []
        return contacts
    } catch (err) {
        throw err
    }
}

const getContactById = async (contact_id) => {
    try {
        const response = await api.get(`/chat/contacts/${contact_id}`)
        const contact = response.data?.data

        return contact || {}
    } catch (err) {
        return {}
    }
}

const getContactsBatch = async (contact_ids) => {
    try {
        const response = await api.post(`/chat/contacts/batch`, {
            contact_ids
        })
        const contacts = response.data?.data

        return contacts || []
    } catch (err) {
        return []
    }
}

const getAllFlags = async () => {
    try {
        const response = await api.get(`/chat/flags`)
        const flags = response.data?.data || []
        return flags
    } catch (err) {
        throw err
    }
}

const getAllLeads = async (conversation_id) => {
    try {
        const response = await api.get(`/chat/conversations/${conversation_id}/leads`)
        const leads = response.data?.data || []
        return leads
    } catch (err) {
        throw err
    }
}

const getConversationById = async (conversation_id) => {
    try {
        const response = await api.get(`/chat/conversations/${conversation_id}`)
        const conversation = response.data?.data || []
        return conversation
    } catch (err) {
        throw err
    }
}

const linkLeadToConversation = async (conversation_id, lead_id) => {
    try {
        const response = await api.post(`/chat/conversations/${conversation_id}/leads/${lead_id}/link`)
        return response.data?.data || {}
    } catch (err) {
        throw err
    }
}

const getConversationGallery = async (conversation_id, { category = "media", skip = 0, limit = 60 } = {}) => {
    try {
        const response = await api.get(`/chat/conversations/${conversation_id}/gallery`, {
            params: { category, skip, limit }
        })
        return response.data?.data || { items: [], has_more: false, next_skip: 0, summary: {} }
    } catch (err) {
        throw err
    }
}

const getConversationGalleryDownload = async (conversation_id, gallery_item_id) => {
    try {
        const response = await api.get(`/chat/conversations/${conversation_id}/gallery/${gallery_item_id}/download`)
        return response.data?.data
    } catch (err) {
        throw err
    }
}

const getConversationGalleryItem = async (conversation_id, gallery_item_id) => {
    try {
        const response = await api.get(`/chat/conversations/${conversation_id}/gallery/${gallery_item_id}`)
        return response.data?.data
    } catch (err) {
        throw err
    }
}

const getAllParticipants = async (conversation_id) => {
    try {
        const response = await api.get(`/chat/conversations/${conversation_id}/participants`)
        const participants = response.data?.data || []
        return participants
    } catch (err) {
        throw err
    }
}

const getMessageTemplatesByInboxId = async (inbox_id, { includeSync = false } = {}) => {
    try {
        const response = await api.get(`/chat/inboxes/${inbox_id}/templates`)
        const templates = response.data?.data || []
        return includeSync ? { templates, sync: response.data?.sync || null } : templates
    } catch (err) {
        throw err
    }
}

const syncMessageTemplatesByInboxId = async (inbox_id) => {
    const response = await api.post(`/chat/inboxes/${inbox_id}/templates/sync`)
    return {
        templates: response.data?.data || [],
        sync: response.data?.sync || null,
        message: response.data?.message || "",
    }
}

const getWhatsAppCallPermission = async (conversation_id) => {
    const response = await api.get(`/chat/conversations/${conversation_id}/calling/permission`)
    return response.data?.data || {}
}

const requestWhatsAppCallPermission = async (conversation_id, message, template = null) => {
    const response = await api.post(`/chat/conversations/${conversation_id}/calling/permission-request`, {
        message,
        ...(template?.name ? {
            template_name: template.name,
            template_language: template.language,
        } : {}),
    })
    return response.data || {}
}

const connectWhatsAppCall = async (conversation_id, sdp) => {
    const response = await api.post(`/chat/conversations/${conversation_id}/calling/connect`, { sdp, sdp_type: "offer" })
    return response.data?.data || {}
}

const actOnWhatsAppCall = async (conversation_id, call_id, action, sdp) => {
    const response = await api.post(`/chat/conversations/${conversation_id}/calling/${encodeURIComponent(call_id)}/${action}`, sdp ? { sdp, sdp_type: "answer" } : {})
    return response.data?.data || {}
}

const saveWhatsAppCallRecording = async (conversation_id, recording) => {
    const response = await api.post(`/chat/conversations/${conversation_id}/calling/recording`, recording)
    return response.data || {}
}

const getSavedMessages = async () => {
    try {
        const response = await api.get(`/chat/saved-messages`)
        const messages = response.data?.data || []
        return messages
    } catch (err) {
        throw err
    }
}

const addNewSavedMessage = async (message) => {
    try {
        const response = await api.post(`/chat/saved-messages`, message)
        return response
    } catch (err) {
        throw err
    }
}

const updateSavedMessage = async (message) => {
    try {
        const response = await api.patch(`/chat/saved-messages/${message?._id}`, message)
        return response
    } catch (err) {
        throw err
    }
}

const deleteSavedMessage = async (message_id) => {
    try {
        const response = await api.delete(`/chat/saved-messages/${message_id}`)
        return response
    } catch (err) {
        throw err
    }
}

const listAssignTo = [
    { id: "teamAndRole", value: "Equipe e Cargo" },
    { id: "users", value: "Usuários" },
]

export { getAllContacts, getContactById, getContactsBatch, getAllFlags, getAllLeads, linkLeadToConversation, getAllParticipants, getConversationById, getConversationGallery, getConversationGalleryDownload, getConversationGalleryItem, getMessageTemplatesByInboxId, syncMessageTemplatesByInboxId, getWhatsAppCallPermission, requestWhatsAppCallPermission, connectWhatsAppCall, actOnWhatsAppCall, saveWhatsAppCallRecording, getSavedMessages, addNewSavedMessage, updateSavedMessage, deleteSavedMessage, listAssignTo }
